import { TextField } from '@mui/material';
import React from 'react';
import CurrencyRangeInput from "../../components/currency-range-input";
import SearchForm from "../../components/search-form";
import { ClientCompanyTypeSelect } from '../../components/MaterialSelects/ClientCompanyTypeSelect';



const CompanySearch = (props)=> {
  const fieldTypes = [
    {
      label: 'Sales Company Name', id: 'salesCompany',
      variants: [{
        id: 'like',
        label: 'Like',
        editor: ({input}) => <TextField {...input} label="Name of sales company"/>
        }
      ]
    }, {
      label: 'Accounts Company', id: 'accountsCompany',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Name of accounts company"/>
        }
      ]
    }, {
      label: 'Sage Customer Account Ref', id: 'accountsCode',
      variants: [
        {
          id: 'exact',
          label: 'Exact',
          editor: ({input}) => <TextField {...input} label="Account Ref" />
        }
      ]
    }, {
      label: 'Accounts Address', id: 'accountsAddress',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Address of accounts company"/>
        }
      ]
    }, {
      label: 'Sales Address', id: 'salesAddress',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} placeholder="Address of sales company"/>
        }
      ]
    }, {
      label: 'Credit Limit', id: 'credit_limit',
      variants: [
        {
          id: 'range',
          label: 'Range',
          clearOnChange:true,
          editor: ({input}) => {
            return (<CurrencyRangeInput {...input} />);
          }
        }
      ]
    }, {
      label: 'Client Type', id: 'client_type',
      variants: [
        {
          id: 'in',
          label: 'Lookup',
          multi: true,
          clearOnChange: true,
          getValue: (val) => {
            return val.id;
          },
          editor: ({input}) => {
            return (<ClientCompanyTypeSelect {...input} valueIsId={true} multiple={true} label="Client Type"/>);
          }
        }
      ]
    }
  ];
    return <SearchForm onCancel={props.onCancel} onSearch={props.onSearch} isOpen={props.isOpen}
                       params={props.params}
                       fieldTypes={fieldTypes}
                       name="company"
                       label="Company "
    />
};

export default CompanySearch;
